import type { CompanyFilters } from "../types";
import { modules, type ModulesSlices, type ModuleKey } from "../modules";
import { deepMerge } from "../utils/deepMerge";

export function composeCompanyFilters(
  slices: ModulesSlices
): CompanyFilters | undefined {
  const partials = (Object.keys(modules) as ModuleKey[]).map((key) => {
    const module = modules[key];
    const slice = slices[key];
    // Type safety: ModulesSlices is a mapped type where each key K maps to modules[K].defaultSlice.
    // TypeScript cannot infer this relationship dynamically, but it's guaranteed by the type system.
    // The 'any' assertion is safe because we're calling the correct module method with its own slice.
    return module.toCompanyFilters(slice as any);
  });
  const merged = deepMerge<CompanyFilters>({} as CompanyFilters, ...partials);
  return Object.keys(merged).length === 0 ? undefined : merged;
}
